module.exports = __webpack_public_path__ + "static/media/servmore.8e474e19.jpeg";